import COMPLEMENTARY_DATA from 'constants/complementaryData'
import { reservationData as reservationE2eClasses } from 'constants/e2eClasses'
import { PASSENGER_TYPES } from 'constants/passengerTypes'

export const getPhoneSpecificProps = ({ initialValues, values, touched, errors }) => ({
  names: {
    phoneType: 'phone_type',
    countryCode: 'contactInformation_countryCode',
    areaCode: 'contactInformation_areaCode',
    phoneNumber: 'contactInformation_phoneNumber'
  },
  e2eClasses: {
    phoneType: reservationE2eClasses.phone,
    countryCode: reservationE2eClasses.country,
    areaCode: reservationE2eClasses.area,
    phoneNumber: reservationE2eClasses.phoneNumber
  },
  initialValues: {
    phoneType: initialValues.phone_type,
    countryCode: initialValues.contactInformation_countryCode,
    areaCode: initialValues.contactInformation_areaCode,
    phoneNumber: initialValues.contactInformation_phoneNumber
  },
  values: {
    phoneType: values.phone_type,
    countryCode: values.contactInformation_countryCode,
    areaCode: values.contactInformation_areaCode,
    phoneNumber: values.contactInformation_phoneNumber
  },
  touched: {
    phoneType: touched.phone_type,
    countryCode: touched.contactInformation_countryCode,
    areaCode: touched.contactInformation_areaCode,
    phoneNumber: touched.contactInformation_phoneNumber
  },
  errors: {
    phoneType: errors.phone_type,
    countryCode: errors.contactInformation_countryCode,
    areaCode: errors.contactInformation_areaCode,
    phoneNumber: errors.contactInformation_phoneNumber
  }
})

export const getPhoneExtraSpecificProps = ({ initialValues, values, touched, errors }) => ({
  names: {
    phoneType: 'phone_extra_type',
    countryCode: 'contactInformation_countryCode_extra',
    areaCode: 'contactInformation_areaCode_extra',
    phoneNumber: 'contactInformation_phoneNumber_extra'
  },
  e2eClasses: {
    phoneType: reservationE2eClasses.phoneExtra,
    countryCode: reservationE2eClasses.countryExtra,
    areaCode: reservationE2eClasses.areaExtra,
    phoneNumber: reservationE2eClasses.phoneNumberExtra
  },
  initialValues: {
    phoneType: initialValues.phone_extra_type,
    countryCode: initialValues.contactInformation_countryCode_extra,
    areaCode: initialValues.contactInformation_areaCode_extra,
    phoneNumber: initialValues.contactInformation_phoneNumber_extra
  },
  values: {
    phoneType: values.phone_extra_type,
    countryCode: values.contactInformation_countryCode_extra,
    areaCode: values.contactInformation_areaCode_extra,
    phoneNumber: values.contactInformation_phoneNumber_extra
  },
  touched: {
    phoneType: touched.phone_extra_type,
    countryCode: touched.contactInformation_countryCode_extra,
    areaCode: touched.contactInformation_areaCode_extra,
    phoneNumber: touched.contactInformation_phoneNumber_extra
  },
  errors: {
    phoneType: errors.phone_extra_type,
    countryCode: errors.contactInformation_countryCode_extra,
    areaCode: errors.contactInformation_areaCode_extra,
    phoneNumber: errors.contactInformation_phoneNumber_extra
  }
})

/** Used when passenger form general names match the specific component field names */
export const getSectionSpecificProps = (
  index,
  formKey,
  initialValues,
  values,
  touched,
  errors
) => ({
  initialValues:
    initialValues.passengers &&
    initialValues.passengers[index] &&
    initialValues.passengers[index][formKey],
  values: values.passengers && values.passengers[index] && values.passengers[index][formKey],
  touched: touched.passengers && touched.passengers[index] && touched.passengers[index][formKey],
  errors: errors.passengers && errors.passengers[index] && errors.passengers[index][formKey]
})

export const buildCountryAreaCode = (code, areaCode) => `${code}${SPLITTER}${areaCode}`

export const SPLITTER = '_$_'

export const getInitialValuesPassengerCheckout = (
  advancedPassengerInformationRules,
  flightSummaryPassengers,
  idOptionsList,
  countryCode,
  countryAreaCode,
  passengers,
  specialRequestsRules
) => {
  const { emergencyContact, contactInformation, passengersData } = passengers || {
    emergencyContact: null,
    contactInformation: null,
    marketingEngagement: true,
    passengersData: []
  }

  return {
    ...(emergencyContact
      ? {
          emergencyContact_name: emergencyContact.name,
          emergencyContact_relationship: emergencyContact.relationship,
          emergencyContact_country: emergencyContact.country,
          emergencyContact_areaCode: emergencyContact.areaCode,
          emergencyContact_phone: emergencyContact.phone
        }
      : {
          emergencyContact_name: '',
          emergencyContact_relationship: '',
          emergencyContact_country: (advancedPassengerInformationRules || []).find(
            item => item.code === COMPLEMENTARY_DATA.PCTC
          )
            ? countryCode
            : '',
          emergencyContact_areaCode: '',
          emergencyContact_phone: ''
        }),

    ...(contactInformation && contactInformation.phones && contactInformation.phones[0]
      ? {
          phone_type: contactInformation.phones[0].type,
          contactInformation_areaCode: (contactInformation.phones[0].areaCode || '').toString(),
          contactInformation_countryCode: (
            contactInformation.phones[0].countryCode || ''
          ).toString(),
          contactInformation_phoneNumber: contactInformation.phones[0].number
        }
      : {
          phone_type: undefined,
          contactInformation_areaCode: '',
          contactInformation_phoneNumber: '',
          contactInformation_countryCode: buildCountryAreaCode(countryCode, countryAreaCode)
        }),

    ...(contactInformation && contactInformation.phones && contactInformation.phones[1]
      ? {
          phone_extra_type: contactInformation.phones[1].type,
          contactInformation_areaCode_extra: contactInformation.phones[1].areaCode,
          contactInformation_countryCode_extra: (
            contactInformation.phones[1].countryCode || ''
          ).toString(),
          contactInformation_phoneNumber_extra: contactInformation.phones[1].number,
          contactInformation_phone_extra: true
        }
      : {
          phone_extra_type: undefined,
          contactInformation_countryCode_extra: buildCountryAreaCode(countryCode, countryAreaCode),
          contactInformation_areaCode_extra: '',
          contactInformation_phoneNumber_extra: '',
          contactInformation_phone_extra: false
        }),

    ...(contactInformation && contactInformation.emails && contactInformation.emails[0]
      ? {
          contactInformation_email: contactInformation.emails[0],
          contactInformation_confirmationEmail: contactInformation.emails[0]
        }
      : {
          contactInformation_email: '',
          contactInformation_confirmationEmail: ''
        }),

    passengers: passengersArray(
      passengersData,
      flightSummaryPassengers,
      advancedPassengerInformationRules,
      idOptionsList,
      countryCode,
      specialRequestsRules
    ),
    acceptTermsAndConditions: false,
    marketingEngagement: true
  }
}

const passengersArray = (
  passengersData,
  flightSummaryPassengers,
  advancedPassengerInformationRules,
  idOptionsList,
  countryCode,
  specialRequestsRules
) => {
  let passengerArray = []
  if (passengersData && passengersData.length > 0) {
    passengerArray.push(
      ...parsePassengersData(
        passengersData,
        advancedPassengerInformationRules,
        idOptionsList,
        specialRequestsRules
      )
    )
  } else if (flightSummaryPassengers) {
    const { adtCount, chdCount, infCount } = flightSummaryPassengers

    for (let i = 0; i < adtCount; i++) {
      passengerArray.push(
        passengerInitialValue(
          countryCode,
          idOptionsList,
          advancedPassengerInformationRules,
          PASSENGER_TYPES.ADT,
          i + 1
        )
      )
    }

    for (let i = 0; i < chdCount; i++) {
      passengerArray.push(
        passengerInitialValue(
          countryCode,
          idOptionsList,
          advancedPassengerInformationRules,
          PASSENGER_TYPES.CHD,
          i + 1
        )
      )
    }

    for (let i = 0; i < infCount; i++) {
      passengerArray.push(
        passengerInitialValue(
          countryCode,
          idOptionsList,
          advancedPassengerInformationRules,
          PASSENGER_TYPES.INF,
          i + 1
        )
      )
    }
  }
  return passengerArray
}

const passengerInitialValue = (
  countryCode,
  idOptionsList,
  advancedPassengerInformationRules,
  passengerType,
  passengerTypeIndex
) => ({
  passengerType,
  passengerTypeIndex,
  passenger_firstName: '',
  passenger_lastName: '',
  passenger_birthdate: '',
  passenger_dayOfBirth: undefined,
  passenger_monthOfBirth: undefined,
  passenger_yearOfBirth: undefined,
  passenger_gender: '',
  passenger_documentType: idOptionsList.length === 1 ? idOptionsList[0].value : undefined,
  passenger_documentNumber: '',
  passenger_expirationDate: undefined,
  passenger_issuingCountry: countryCode,
  passenger_nationality: countryCode,
  passenger_frequentFlyerInfo: false,
  passenger_specialPreferences: false,
  passenger_airline: countryCode,
  passenger_membershipNumber: '',
  passenger_ssr: '',
  passenger_mealPreference: undefined,
  passenger_specialServiceRequests: undefined,
  passenger_redressNumber: false,
  passenger_compensationNumber: '',
  passenger_expirationDay: undefined,
  passenger_expirationMonth: undefined,
  passenger_expirationYear: undefined,
  showDOCAAddresses:
    (advancedPassengerInformationRules || []).find(item => item.code === COMPLEMENTARY_DATA.DOCA) &&
    passengerType !== PASSENGER_TYPES.INF,
  residentialAddress: {
    country: undefined,
    street: '',
    zipCode: '',
    state: '',
    city: '',
    copyFromFirstPassenger: false
  },
  destinationAddress: {
    country: undefined,
    street: '',
    zipCode: '',
    state: '',
    city: '',
    copyFromFirstPassenger: false
  },
  passengerUnder17: false
})

const parsePassengersData = (
  passengersData,
  advancedPassengerInformationRules,
  idOptionsList,
  specialRequestsRules
) =>
  (passengersData || []).map(passenger => {
    const keyPassengerType = Object.keys(PASSENGER_TYPES)
      .map((key, index) => ({ key, index }))
      .find(ob => ob.key === passenger.passengerType)

    const valuePassengerType = Object.values(PASSENGER_TYPES)
      .map((key, index) => ({ key, index }))
      .find(ob => [keyPassengerType.index, -1].includes(ob.index))

    return {
      passengerTypeIndex: passenger.passengerIndex,
      passengerType: valuePassengerType?.key,
      passenger_firstName: passenger.firstName,
      passenger_lastName: passenger.lastName,
      passenger_birthdate: passenger.birthDate,
      passenger_dayOfBirth: passenger.birthDate
        ? new Date(passenger.birthDate).getDate()
        : undefined,
      passenger_monthOfBirth: passenger.birthDate
        ? new Date(passenger.birthDate).getMonth() + 1
        : undefined,
      passenger_yearOfBirth: passenger.birthDate
        ? new Date(passenger.birthDate).getFullYear()
        : undefined,
      passenger_gender: passenger.gender,

      ...(passenger && passenger.document
        ? {
            passenger_documentType: (idOptionsList || []).find(
              item => item.value === passenger.document.documentType
            )?.value,
            passenger_documentNumber: passenger.document.documentNumber,
            passenger_nationality: passenger.document.nationality,
            passenger_issuingCountry: passenger.document.issuingCountry,
            passenger_expirationDate: passenger.document.expirationDate,
            passenger_expirationDay: passenger.document.expirationDate
              ? new Date(passenger.document.expirationDate).getDate()
              : undefined,
            passenger_expirationMonth: passenger.document.expirationDate
              ? new Date(passenger.document.expirationDate).getMonth() + 1
              : undefined,
            passenger_expirationYear: passenger.document.expirationDate
              ? new Date(passenger.document.expirationDate).getFullYear()
              : undefined
          }
        : {
            passenger_documentType: undefined,
            passenger_documentNumber: '',
            passenger_nationality: undefined,
            passenger_issuingCountry: undefined,
            passenger_expirationDate: undefined,
            passenger_expirationDay: undefined,
            passenger_expirationMonth: undefined,
            passenger_expirationYear: undefined
          }),

      ...(passenger &&
      passenger.frequentFlyerInformation &&
      passenger.frequentFlyerInformation.airline
        ? {
            passenger_frequentFlyerInfo: true,
            passenger_airline: passenger.frequentFlyerInformation.airline,
            passenger_membershipNumber: passenger.frequentFlyerInformation.number
          }
        : {
            passenger_frequentFlyerInfo: false,
            passenger_airline: undefined,
            passenger_membershipNumber: ''
          }),

      ...(passenger &&
      passenger.specialPreferences &&
      (passenger.specialPreferences.mealPreference || []).length > 0
        ? {
            passenger_specialPreferences: true,
            passenger_mealPreference: (
              (
                ((specialRequestsRules && specialRequestsRules.ssrTypes) || []).find(
                  x => x.type === 'MEAL'
                )?.availableSSRs || []
              ).filter(x => x.code === passenger.specialPreferences.mealPreference) || []
            ).map(x => ({ label: x.name, value: x.code }))[0],
            passenger_specialServiceRequests: (
              (
                ((specialRequestsRules && specialRequestsRules.ssrTypes) || []).find(
                  x => x.type === 'SPECIAL_REQUEST'
                )?.availableSSRs || []
              ).filter(f =>
                (
                  (passenger.specialPreferences &&
                    passenger.specialPreferences.specialServiceRequests) ||
                  []
                )
                  .map(x => x.code)
                  .includes(f.code)
              ) || []
            ).map(x => ({ label: x.name, value: x.code }))
          }
        : {
            passenger_specialPreferences: false,
            passenger_mealPreference: undefined,
            passenger_specialServiceRequests: undefined
          }),

      passenger_redressNumber: false,
      passenger_ssr: '',
      passenger_compensationNumber: '',
      showDOCAAddresses:
        (advancedPassengerInformationRules || []).find(
          item => item.code === COMPLEMENTARY_DATA.DOCA
        ) && passenger.passengerType !== PASSENGER_TYPES.INF,
      residentialAddress: {
        country: undefined,
        street: '',
        zipCode: '',
        state: '',
        city: '',
        copyFromFirstPassenger: false
      },

      destinationAddress: {
        country: undefined,
        street: '',
        zipCode: '',
        state: '',
        city: '',
        copyFromFirstPassenger: false
      },

      passengerUnder17: false
    }
  })
